module.exports = __webpack_public_path__ + "static/media/japan.1f905d23.svg";